var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91615 6.00007L10.8099 2.10608C11.0634 1.85279 11.0634 1.44325 10.8099 1.18997C10.5567 0.936678 10.1471 0.936678 9.89386 1.18997L5.99994 5.08396L2.10614 1.18997C1.85274 0.936678 1.44333 0.936678 1.19005 1.18997C0.93665 1.44325 0.93665 1.85279 1.19005 2.10608L5.08385 6.00007L1.19005 9.89407C0.93665 10.1474 0.93665 10.5569 1.19005 10.8102C1.31628 10.9365 1.48225 11 1.6481 11C1.81395 11 1.9798 10.9365 2.10614 10.8102L5.99994 6.91618L9.89386 10.8102C10.0202 10.9365 10.1861 11 10.3519 11C10.5178 11 10.6836 10.9365 10.8099 10.8102C11.0634 10.5569 11.0634 10.1474 10.8099 9.89407L6.91615 6.00007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCross);
export default __webpack_public_path__ + "static/media/WhiteCross.2c3803ad81ad90f02272d43fc3101f6c.svg";
export { ForwardRef as ReactComponent };